import numeral from 'numeral';

const DEFAULT_PERCENTAGE_FORMAT = '0,0.00%';
const DECIMALS_NUMBER = 2;

export const roundNumberWithUom = (
  number: number | string,
  decimals: number | string,
  uom?: string
) => {
  if (!number) {
    return '-';
  }

  return `${roundNumber(number, decimals)}/${uom || ' -'}`;
};

export const roundNumber = (
  number: number | string,
  decimals: number | string,
  showCurrency = true
) => {
  if (!number) {
    return '-';
  }

  if (!showCurrency) {
    return Number(number).toFixed(Number(decimals));
  }

  return `$${Number(number).toFixed(Number(decimals))}`;
};

export const getPercentage = (
  value: number,
  format = DEFAULT_PERCENTAGE_FORMAT,
  placeholder?: string
) => {
  if (!value && value !== 0) {
    return placeholder || '-';
  }

  return numeral(value).format(format);
};

export const getInt = (value: number | string) => {
  if (!value || !Number(value)) {
    return '-';
  }

  return numeral(value).format('0,0');
};

export const getQuantity = (
  amount: number,
  format?: string,
  thousandsSeparator?: boolean,
  decimals?: number,
  placeholder?: string,
  allowZeroAmount = true
) => {
  if (!amount || (0 === amount && !allowZeroAmount)) {
    return placeholder || '-';
  }

  let numberFormat;
  const decimalsNumber = decimals || DECIMALS_NUMBER;
  const isThousandSeparator = thousandsSeparator || true;

  if (isThousandSeparator) {
    numberFormat = format || '0,0.' + '[' + Array(decimalsNumber + 1).join('0') + ']';
  } else {
    numberFormat = format || '0.' + '[' + Array(decimalsNumber + 1).join('0') + ']';
  }

  return numeral(amount).format(numberFormat);
};

export const getRawQuantity = (amount: number, decimals: number) => {
  return getQuantity(amount, undefined, false, decimals);
};
